import FilterConcept from "components/FilterConcept/FilterConcept.vue"
import ListItem from "components/ListItemsAndCards/ListItem/ListItem.vue"
import PageControls from "components/PageControls/PageControls.vue"
import { useSearchStore } from "stores/search.store"
import { computed, onMounted, ref, watch } from "vue"

export default {
    name: "ListPageList",
    components: {
        FilterConcept,
        ListItem,
        PageControls
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false,
            default: "list"
        },
        filters: {
            type: Object,
            required: false
        },
        initList: {
            type: Array,
            default: [],
            required: false
        },
        labels: {
            type: Object,
            required: true
        },
        take: {
            type: Number,
            default: 6,
            required: false
        },
        totalHits: {
            type: Number,
            default: 0,
            required: false
        }
    },
    setup(props) {
        const searchStore = useSearchStore()
        const TYPE_API = Object.freeze({
            LIST: process.env.LIST_DEFAULT_LIST.replace("[guid]", props.guid),
            NEWS: process.env.LIST_NEWS_LIST.replace("[guid]", props.guid),
            SEARCH: process.env.LIST_SEARCH_LIST.replace("[guid]", props.guid),
            CAREERS: process.env.LIST_CAREERS_LIST.replace("[guid]", props.guid)
        })

        const api = TYPE_API[props.type.toUpperCase()]
        const currentPage = ref(1)

        const loading = computed(() => searchStore.loading)
        const list = ref(props.initList ?? [])
        const resultList = computed(() => searchStore.results[props.type] ?? [])
        const currentResultCount = computed(() => list.value.length)
        const totalResultCount = computed(() => searchStore.totalHits[props.type] ?? props.totalHits)

        watch(resultList, (newVal) => {
            list.value = newVal
        })

        watch(currentPage, (newVal) => {
            if (newVal > 1) {
                searchStore.getMoreResults({ guid: props.guid, searchKey: props.type, replaceResults: false })
            }
        })
        
        onMounted(() => {
            if (props.initList) {
                searchStore.setResults({ guid: props.guid, searchKey: props.type, results: props.initList })
            }
            if (props.filters) {
                searchStore.setFilters({ guid: props.guid, searchKey: props.type, filters: props.filters })
            }
            if (api) {
                searchStore.setSearchUrl({ guid: props.guid, searchKey: props.type, url: api })
            }
            searchStore.setTakeSize({ guid: props.guid, searchKey: props.type, take: props.take })
            searchStore.setCurrentPage({ searchKey: props.type, })

            totalResultCount.value = list.value.length
        })

        const loadMoreCallback = function() {
            currentPage.value = currentPage.value + 1
        }

        return {
            totalResultCount,
            currentResultCount,
            list,
            loading,
            loadMoreCallback
        }
    }
}